export function counter() {
    window.addEventListener('load', runCountersAnimation);

    function runCountersAnimation() {
        function digitsCountersInit(digitsCountersItems) {
            const digitsCounters = digitsCountersItems ? digitsCountersItems : document.querySelectorAll("[data-digits-counter]");
            if (digitsCounters.length) {
                digitsCounters.forEach(digitsCounter => {
                    digitsCountersAnimate(digitsCounter);
                })
            }
        }

        function digitsCountersAnimate(digitsCounter) {
            let startTimestamp = null;
            const duration = parseInt(digitsCounter.dataset.digitsCounter) ? parseInt(digitsCounter.dataset.digitsCounter) : 2000;
            const startValue = digitsCounter.innerText;
            const startValueParsed = parseInt(startValue.replace(/,/g, ''));
            const startPosition = 0;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                let currentCount = Math.floor(progress * (startPosition + startValueParsed));
                if (startValue.includes(',')) {
                    currentCount = currentCount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }
                digitsCounter.innerHTML = currentCount;
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        // run on scroll
        const options = {threshold: 0.3};
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const targetElement = entry.target;
                    const digitsCountersItems = targetElement.querySelectorAll("[data-digits-counter]");
                    if (digitsCountersItems.length) {
                        digitsCountersInit(digitsCountersItems);
                    }
                    observer.unobserve(targetElement);
                }
            });
        }, options);
        const countersSections = document.querySelectorAll(".has-counters-animation");
        if (countersSections.length) {
            countersSections.forEach(section => {
                observer.observe(section);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/counter.js